module.exports = "<div class=\"row\">\n\n  <div class=\"pie-chart-target col-sm-4\">\n    \n  </div>\n\n  <div class=\"col-sm-8\">\n    <div *ngIf=\"selected\" class=\"card\">\n      <div class=\"card-header\">\n        <pre>{{ selected | json }}</pre>\n      </div>\n    </div>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/andyperlitch/repos/ngx-d3-tooltip/src/app/components/interactive-pie-chart/interactive-pie-chart.component.html
// module id = ../../../../../src/app/components/interactive-pie-chart/interactive-pie-chart.component.html
// module chunks = main